<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/staffing',
          title: 'Staffing'
        }
      ]"
      :value="staffingPage.hero_section"
    >
      <template v-if="staffingPage.hero_section.cta" #cta>
        <HeroCta :value="staffingPage.hero_section.cta" />
      </template>
    </HeroSection>

    <ServiceDifferentiatorsSection
      :value="staffingPage.service_differentiators_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="staffingPage.logo_bar_section"
      class="mb-16"
    />

    <ServiceDetailSection
      class="mb-16"
      :value="staffingPage.service_detail_section"
    />

    <CaseStudiesSliderSection
      :value="staffingPage.case_studies_slider_section"
      class="mb-16"
    />

    <CrossSellSection :value="staffingPage.cross_sell_section" class="mb-16" />

    <PromotedResourcesSection
      :value="staffingPage.promoted_resources_section"
      class="mb-16"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="staffingPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
defineProps({
  logos: {
    required: true,
    type: Array
  },
  staffingPage: {
    required: true,
    type: Object
  }
})
</script>
